// ── FitText — короткая надпись, которая всегда помещается в одну строку ──────
// Для подписей в тесных местах (нижняя панель, плашки): если при этом шрифте и языке
// слово не влезает («Estadísticas» пиксельным шрифтом на узком телефоне), размер
// уменьшается по полпикселя, но не меньше min. Не помогло — «…» и подсказка.
// Пересчитывается при смене ширины и когда догрузился шрифт (тема «Аркада»).

import { useLayoutEffect, useRef } from 'react';

export default function FitText({ children, size, min = 9, style, title, ...rest }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const fit = () => {
      let fs = size;
      el.style.fontSize = `${fs}px`;
      while (el.scrollWidth > el.clientWidth + 0.5 && fs > min) {
        fs = Math.max(min, fs - 0.5);
        el.style.fontSize = `${fs}px`;
      }
    };
    fit();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(fit) : null;
    ro?.observe(el.parentElement || el);
    const fonts = typeof document !== 'undefined' ? document.fonts : null;
    fonts?.addEventListener?.('loadingdone', fit);
    return () => { ro?.disconnect(); fonts?.removeEventListener?.('loadingdone', fit); };
  }, [children, size, min]);
  return (
    <span ref={ref} title={title || (typeof children === 'string' ? children : undefined)}
      style={{ display: 'block', maxWidth: '100%', minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: size, ...style }}
      {...rest}>{children}</span>
  );
}
